import { IsOptional, IsNumber, Min } from 'class-validator';

export class ListQuery {
  @IsOptional()
  @IsNumber()
  @Min(1)
  public limit?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  public offset?: number;

  constructor(
    limit?: number,
    offset?: number,
  ) {
    this.limit = limit;
    this.offset = offset;
  }
}
